export function getPriceYuanAndFen(price?: string) {
  if (!price) return { priceYuan: "", priceFen: "" };

  const index = String(price).indexOf(".");
  if (index === -1) return { priceYuan: price, priceFen: "" };

  return {
    priceYuan: price.slice(0, index),
    priceFen: price.slice(index + 1, index + 3),
  };
}
